// External Library Imports
import React from "react";

// React-Bootstrap Component Imports
import { Row, Col } from "react-bootstrap";

// Local Component Imports
import SearchMessage from "../../../SearchMessage/SearchMessage";

// Type, Interface, and Styled Component Imports
import { DisplaySwitch } from "./../../SearchResultHelpers";

interface SearchHeaderProps {
  isLoading: boolean;
  hotelCount: number;
  searchString: string;
  priceFilter: any; // Adjust the type as needed
  display: string;
  handleSetDisplay: (display: string) => void;
  isMobile: boolean;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({
  isLoading,
  hotelCount,
  searchString,
  priceFilter,
  display,
  handleSetDisplay,
  isMobile,
}) => {
  return (
    <Row className="search-header px-2">
      <Col className={`${isLoading ? "invisible" : "visible"}`}>
        <SearchMessage
          hotelCount={hotelCount}
          searchString={searchString}
          priceFilter={priceFilter}
        />
      </Col>

      <Col
        xs={{ span: 2 }}
        className={`${
          isLoading ? "invisible" : "visible"
        } d-flex align-items-end flex-column`}
      >
        <DisplaySwitch>
          <button className={`d-flex ${display}`}>
            <span
              id="list-view-button"
              className="switch-list"
              aria-label={"List View"}
              onClick={() => handleSetDisplay("list")}
            >
              <svg className="list-icon">
                <use xlinkHref="/svg/listview.svg#listview"></use>
              </svg>
              {isMobile ? "" : "List"}
            </span>
            <span
              id="map-view-button"
              className="switch-map"
              aria-label={"Map View"}
              onClick={() => handleSetDisplay("map")}
            >
              <svg className="map-icon">
                <use xlinkHref="/svg/mapview.svg#mapview"></use>
              </svg>
              {isMobile ? "" : "View on Map"}
            </span>
          </button>
        </DisplaySwitch>
      </Col>
    </Row>
  );
};

export default SearchHeader;
